import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getServiceProviders } from '../../api/directory';
import { errors } from '../../constants';
import { AutoComplete } from '@otcmarketsgroup/otcm-ui-lib';

const PLACEHOLDER_NA = 'N/A';

const ServiceProviderSearch = ({ value, typeId, notAvailable, isRequired, readOnly, disabled, disableSearch, onValueChanged, onDetailSelect, error }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const [searchResults, setSearchResults] = useState([]);
    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    useEffect(() => {
        if (disabled) {
            setInputValue('');
            setSearchResults([]);
        }
    }, [disabled]);

    const onInputChange = (_event, nextInputValue) => {
        const nextValue = nextInputValue || '';
    if (nextValue?.length === 76) return;
        setInputValue(nextValue);
        onValueChanged(nextValue);

        if (disableSearch || !nextValue || nextValue.length === 0) {
            setSearchResults([]);
            return;
        }

        getServiceProviders(typeId, nextValue).then(data => {
            const results = Array.isArray(data) ? data : [];
            setSearchResults(results);
        });
    };

    const handleSelect = (_event, selected) => {
        const selectedName = typeof selected === 'string' ? selected : selected?.name || '';
        setInputValue(selectedName);
        if (onDetailSelect && typeof selected === 'object') onDetailSelect(selected);
        onValueChanged(selectedName);
    };

    const selectedOption = searchResults.find(item => item.name === inputValue) || null;

    return (
        <AutoComplete
            options={searchResults}
            freeSolo
            value={selectedOption || inputValue}
            inputValue={inputValue}
            getOptionLabel={option => typeof option === 'string' ? option : option?.name || ''}
            isOptionEqualToValue={(option, selected) => option?.id ? option.id === selected?.id : option?.name === selected?.name}
            onInputChange={onInputChange}
            onChange={handleSelect}
            disabled={disabled}
            readOnly={readOnly}
            error={error}
            helperText={error ? errors.INCOMPLETE_DATA : ''}
            label='Name of Firm'
            placeholder={notAvailable ? PLACEHOLDER_NA : 'Name of Firm'}
            textFieldProps={{
                name: 'name',
                required: isRequired
            }}
        />
    );
};

ServiceProviderSearch.propTypes = {
  value: PropTypes.string,
  typeId: PropTypes.string,
  notAvailable: PropTypes.bool,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  disableSearch: PropTypes.bool,
  onValueChanged: PropTypes.func,
  onDetailSelect: PropTypes.func
};

export default ServiceProviderSearch;
